import classNames from "classnames";
import { use } from "react";
import { useNavigate } from "react-router";
import { BikeContext } from "../context/bikeContext";
import { useBikes } from "../hooks/useBikes";
import styles from "./BikeSelectBottomSheet.module.css";
import BottomSheet from "./BottomSheet";
import Button from "./Button";
import Icon from "./Icon";
import Check from "./icons/check.svg?react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BikeSelectBottomSheet = ({ isOpen, onClose }: Props) => {
  const { bike, setBike } = use(BikeContext);
  const { data: bikes } = useBikes(5, isOpen);
  const navigate = useNavigate();

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <h3>Your Bikes</h3>
      <ul className={styles.bikes}>
        {bikes?.items?.map((b) => (
          <li key={b.id}>
            <span
              onClick={() => {
                onClose();
                setBike(b)
                  .then(() => {
                    navigate("/setups");
                  })
                  .catch(() => {
                    // TODO: Show error notification
                  });
              }}
              className={classNames(styles.bike, {
                [styles.active]: b.id === bike?.id,
              })}
            >
              {b.name}
              {b.id === bike?.id && (
                <Icon className={styles.selectedIcon} glyph={Check} />
              )}
            </span>
          </li>
        ))}
      </ul>
      <Button
        fullWidth
        buttonProps={{
          className: styles.button,
          onClick: () => {
            navigate("/garage");
          },
        }}
      >
        Add & manage bikes
      </Button>
    </BottomSheet>
  );
};

export default BikeSelectBottomSheet;
